module.exports = __webpack_public_path__ + "static/24-f8aebfde88fadb0203b047b09b5d2688.png";